import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { IconButton, MobileStepper, useTheme } from '@mui/material';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';
import {
  INSURANCE_TYPE_PETOLO,
  GET_CUSTOMER,
  INSURANCE_TYPE_DENTOLO,
  INSURANCE_TYPE_VITOLO,
} from '../../../shared';
import CaretLeftIcon from '../../../icons/CaretLeftIcon';
import CaretRightIcon from '../../../icons/CaretRightIcon';

import { filterValidSlides } from './carouselHelper';
import {
  promotionSlidesDentolo,
  promotionSlidesPetolo,
  promotionSlidesVitolo,
} from './carouselSlides';

import {
  StyledCarouselControls,
  StyledPromotionCarouselPaper,
  StyledPromotionCarouselSlider,
} from './PromotionCarousel.styled';

const slidesMap = {
  [INSURANCE_TYPE_DENTOLO]: promotionSlidesDentolo,
  [INSURANCE_TYPE_PETOLO]: promotionSlidesPetolo,
  [INSURANCE_TYPE_VITOLO]: promotionSlidesVitolo,
};

const PromotionCarousel = () => {
  const theme = useTheme();

  const { type: insuranceType } = useInsuranceInfo();
  const { data: customerData } = useQuery(GET_CUSTOMER);

  const riskCarrier = customerData?.customer?.contract?.riskCarrier;

  const currentPolicyCategory = customerData?.customer?.contract?.policyCategory;
  const slidesToUse = slidesMap[`${insuranceType}`] || [];

  const slidesToBeDisplayed = filterValidSlides(slidesToUse, currentPolicyCategory, riskCarrier);

  const totalNumberOfSlides = slidesToBeDisplayed?.length || 0;

  const [currentSlideNumber, setCurrentSlideNumber] = useState(0);

  const goToSlide = (index) => {
    setCurrentSlideNumber((index + totalNumberOfSlides) % totalNumberOfSlides);
  };

  if (!Array.isArray(slidesToBeDisplayed) || totalNumberOfSlides < 1) return null;

  return (
    <StyledPromotionCarouselPaper
      component="section"
      data-testid="home-carousel-card"
      data-product-test-id={`${insuranceType}-home-carousel-card`}
      aria-roledescription="carousel"
      aria-label="Promotions"
    >
      <StyledPromotionCarouselSlider
        id="promotion_carousel_items"
        role="group"
        aria-roledescription="slide"
        aria-label={`Slide ${currentSlideNumber + 1} of ${totalNumberOfSlides}`}
      >
        {slidesToBeDisplayed.at(currentSlideNumber)?.card}
      </StyledPromotionCarouselSlider>

      {totalNumberOfSlides > 1 && (
        <StyledCarouselControls>
          <MobileStepper
            variant="dots"
            steps={totalNumberOfSlides}
            position="static"
            activeStep={currentSlideNumber}
            backButton={
              <IconButton
                size="medium"
                onClick={() => goToSlide(currentSlideNumber - 1)}
                aria-label="Previous slide"
                aria-controls="promotion_carousel_items"
              >
                <CaretLeftIcon stroke={theme.palette.main.professional_blue} />
              </IconButton>
            }
            nextButton={
              <IconButton
                size="medium"
                onClick={() => goToSlide(currentSlideNumber + 1)}
                aria-label="Next slide"
                aria-controls="promotion_carousel_items"
              >
                <CaretRightIcon stroke={theme.palette.main.professional_blue} />
              </IconButton>
            }
          />
        </StyledCarouselControls>
      )}
    </StyledPromotionCarouselPaper>
  );
};

export default PromotionCarousel;
